
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Metz dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Metz certifiée Google Partner, aide les entreprises messines à booster leur visibilité en ligne et à gagner de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Metz dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Metz certifiée Google Partner, aide les entreprises messines à booster leur visibilité en ligne et à gagner de nouveaux clients.",
        },
      ],
    };
  },
};
